import React, { FC, useMemo } from 'react'

import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { useGetReportsHistory } from 'pages/your-personal-data/hooks/useGetReportsHistory'
import { isEmpty } from 'lodash'
import { Loader, ErrorHandler } from 'components'
import { makeTraceDetails } from 'common'

import { groupedAndSortedReportsByYearAndMonth } from '../utils/functions'
import { NoAvailableReports } from '../no-available-reports/NoAvailableReports'
import { ReportsAvailableContainer } from './styles'
import { ReportsYearSection } from '../reports-year-section/ReportsYearSection'

export const ReportsAvailable: FC = () => {
  const { userLanguage, privacyCenterContent, isAppError } = useAppContext()

  const { reports, isReportsLoading, isReportsError } = useGetReportsHistory()

  const groupedAndSortedReports = useMemo(() => {
    if (!reports || !userLanguage) return undefined

    return groupedAndSortedReportsByYearAndMonth(reports, userLanguage)
  }, [reports, userLanguage])

  const years = useMemo(() => {
    if (!groupedAndSortedReports) return undefined

    return Object.keys(groupedAndSortedReports).sort((a, b) => {
      if (a < b) return 1
      if (a > b) return -1
      return 0
    })
  }, [groupedAndSortedReports])

  const content = privacyCenterContent?.components?.reportsHistory?.content?.availableReports

  if (isReportsLoading)
    return <Loader pxToSubtractFrom100vh={300} message={content?.loadingMessage ?? ''} />

  const isAcitve = privacyCenterContent?.components?.reportsHistory?.isActive

  const isErrorOrInactive = isAppError || isReportsError || isEmpty(content) || !isAcitve

  if (isErrorOrInactive) {
    const traceDetails = makeTraceDetails(!!isAcitve, content)

    return <ErrorHandler traceDetails={traceDetails} componentName={ReportsAvailable.name} />
  }

  if (isEmpty(reports)) return <NoAvailableReports description={content?.noReportsMessage} />

  return (
    <ReportsAvailableContainer>
      {years &&
        groupedAndSortedReports &&
        years.map((year) => (
          <ReportsYearSection
            key={year}
            year={year}
            reporstByYear={groupedAndSortedReports[year]}
          />
        ))}
    </ReportsAvailableContainer>
  )
}
